module.exports = __webpack_public_path__ + "img/white.733e7f3a.png";